import {EAuthSessionData} from "../types/auth";

function fn(haveSubscription: boolean): boolean {
    return haveSubscription;
}

export default fn;
